import { Link, useParams } from 'react-router-dom';
import { Button } from '../../components/ui/Button.js';
import { Card, CardBody, CardHeader, CardTitle } from '../../components/ui/Card.js';
import { useNina } from '../../lib/queries/ninas.js';

export function NinasView() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, error } = useNina(id);

  if (isLoading) {
    return <div className="text-center py-8 text-gray-600">Cargando…</div>;
  }
  if (error) {
    return (
      <Card>
        <CardBody>
          <p className="text-red-600">Error: {error.message}</p>
          <Link to="/ninas">
            <Button variant="ghost" className="mt-4">
              ← Regresar al padrón
            </Button>
          </Link>
        </CardBody>
      </Card>
    );
  }
  if (!data) return null;
  const nina = data.data;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-gray-900">{nina.nombre_completo}</h1>
        <Link to={`/ninas/${nina.entity_id}/edit`}>
          <Button variant="primary">Editar</Button>
        </Link>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Datos generales</CardTitle>
        </CardHeader>
        <CardBody>
          <dl className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
            <div>
              <dt className="font-medium text-gray-500">Folio GDM</dt>
              <dd className="mt-1 font-mono">{nina.folio_gdm}</dd>
            </div>
            <div>
              <dt className="font-medium text-gray-500">Fecha de nacimiento</dt>
              <dd className="mt-1">{nina.fecha_nacimiento}</dd>
            </div>
            <div>
              <dt className="font-medium text-gray-500">Rama actual</dt>
              <dd className="mt-1">{nina.rama_actual}</dd>
            </div>
            <div>
              <dt className="font-medium text-gray-500">Estatus</dt>
              <dd className="mt-1">
                <span className="inline-block px-2 py-0.5 bg-distrito-100 text-distrito-800 rounded text-xs">
                  {nina.estatus}
                </span>
              </dd>
            </div>
            <div>
              <dt className="font-medium text-gray-500">Fecha de alta</dt>
              <dd className="mt-1">{nina.fecha_alta}</dd>
            </div>
            <div>
              <dt className="font-medium text-gray-500">Tutor</dt>
              <dd className="mt-1">{nina.tutor_nombre}</dd>
            </div>
            <div>
              <dt className="font-medium text-gray-500">Email tutor</dt>
              <dd className="mt-1">{nina.tutor_email}</dd>
            </div>
            <div>
              <dt className="font-medium text-gray-500">Teléfono tutor</dt>
              <dd className="mt-1">{nina.tutor_telefono}</dd>
            </div>
          </dl>
        </CardBody>
      </Card>

      <Link to="/ninas">
        <Button variant="ghost">← Regresar al padrón</Button>
      </Link>
    </div>
  );
}
